import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IDiscipline } from 'corporate/types';

export const getAllDisciplines = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IDiscipline>> => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/discipline-list/disciplines?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IDiscipline>(data.data, data.recordsFiltered);
};
